export const SWEDISH = 'sv';
export const ENGLISH = 'en';
